import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import SystemButton from './SystemButton'
import BrowserButton from './BrowserButton'
import PropTypes from 'prop-types'

export default function ButtonsGroup(props) {
  return (
    <div className="col">
      <SystemButton
        sysName={props.sysName}
        info={props.info}
        isOpen={props.isOpen}
        isOpenAll={props.isOpenAll}
        setIsOpen={props.setIsOpen}
      />
      <br />
      {props.isOpen && (
        <ButtonGroup vertical className="d-flex">
          {Object.keys(props.buttons).map(key => (
            <BrowserButton
              key={key}
              platformName={key}
              link={props.buttons[key]}
            />
          ))}
        </ButtonGroup>
      )}
    </div>
  )
}

ButtonsGroup.propTypes = {
  sysName: PropTypes.string,
  info: PropTypes.string,
  isOpen: PropTypes.bool,
  isOpenAll: PropTypes.object,
  setIsOpen: PropTypes.func,
  buttons: PropTypes.object,
}
